import Boys from "../components/Products/Boys/Boys";
import Girls from "../components/Products/Girls/Girls";
import Mens from "../components/Products/Mens/Mens";
import Womens from "../components/Products/Womens/Womens";


export default function Product() {
  return <div>
    <></>
   <Mens/>
   <br></br>
   <hr></hr>
   <Womens/>
   <br></br>
  <Boys/><br></br>
  <hr></hr>
   <br></br>
   <Girls/>
   <br></br>
  </div>
  
  
}
